import { TranslationObject } from './en';

export const langPt: TranslationObject = {
  'common.expected_finish': 'Término esperado',
  'common.minutes': 'min',
  'common.now': 'Agora',
  'common.next': 'Próximo',
  'common.public_message': 'Mensagem pública',
  'common.scheduled_start': 'Início programado',
  'common.scheduled_end': 'Fim programado',
  'common.projected_start': 'Início previsto',
  'common.projected_end': 'Fim previsto',
  'common.stage_timer': 'Temporizador do presentador',
  'common.started_at': 'Iniciado em',
  'common.time_now': 'Hora atual',
  'countdown.ended': 'Evento encerrado às',
  'countdown.running': 'Evento em andamento',
  'countdown.select_event': 'Selecione um evento para acompanhar',
  'countdown.to_start': 'Tempo para iniciar',
  'countdown.waiting': 'Aguardando o início do evento',
  'countdown.overtime': 'em tempo extra',
  'timeline.live': 'live',
  'timeline.done': 'Concluído',
  'timeline.due': 'Pendente',
  'timeline.followedby': 'Seguido por',
};
